window.addEventListener("breeze-initiate-checkout", (event) => {
  const eventData = event.detail;
  breezeCheckoutInit(eventData);
});

// This function will be invoked by breeze after purchase
function breezeCheckoutInit(payload) {
  try {
    pushCheckoutInitEvent(payload.data); // new dataLayer push
  } catch (e) {
    console.log("Error in triggering merchant scripts: ", e);
  }
}

// CHECKOUT INIT EVENT (custom, not Google Ads)
function pushCheckoutInitEvent(data) {
  if (!data) return;

  const ecommerceItems = (data.items || []).map((item, index) => ({
    item_id: String(item.id),
    item_name: item.name,
    price: item.price,
    quantity: item.quantity,
    currency: item.currency,
    index: index,
    item_variant: item.variant,
    item_brand: "", // optional, fill if available
    item_category: "", // optional, fill if available
    item_list_id: "", // optional
    item_list_name: "", // optional
    coupon: data.coupon || "", // optional
    affiliation: "", // optional
    discount: 0, // optional, set if available
  }));
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "checkout-init",
    ecommerce: {
      currency: data.currency || "INR",
      value: data.totalPrice || 0,
      coupon: data.coupon || "",
      items: ecommerceItems,
    },
  });
}

window.addEventListener("breeze-add-payment-info", (event) => {
  const eventData = event.detail;
  pushPaymentScreenEvent(eventData.data);
});

// Push custom event to dataLayer
function pushPaymentScreenEvent(data) {
  if (!data || !data.items) return;

  const user = data.userDetails || {};
  const nameParts = (user.name || "").split(" ");
  const firstName = nameParts[0] || "";
  const lastName = nameParts.slice(1).join(" ") || "";

  const ecommerceItems = data.items.map((item, index) => ({
    item_id: String(item.id || item.item_id || ""),
    item_name: item.name || item.item_name || "",
    affiliation: item.affiliation || "",
    coupon: item.coupon || "",
    discount: item.discount || 0,
    item_brand: item.item_brand || "",
    item_category: item.item_category || "",
    item_list_id: item.item_list_id || "",
    item_list_name: item.item_list_name || "",
    item_variant: String(item.variant || ""),
    price: item.price,
    quantity: item.quantity,
  }));

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "payment-screen",
    phone_num: user.phone || "",
    first_name: firstName,
    last_name: lastName,
    email: user.email || "",
    city: user.city || "",
    state: user.state || "",
    pincode: user.postalCode || "",
    country: user.countryCode || "",
    ecommerce: {
      currency: data.currency || "INR",
      value: data.totalPrice || data.value || 0,
      coupon: "",
      tax: 0,
      shipping: data.shippingCharge || 0,
      transaction_id: data.shopOrderId || "",
      paymentType: "", // Not provided in payload
      shipping_tier: "", // Not provided in payload
      items: ecommerceItems,
    },
  });
}

window.addEventListener("breeze-purchase", (event) => {
  const eventData = event.detail;
  pushOrderPlacedEvent(eventData.data);
});

// Push custom event to dataLayer
function pushOrderPlacedEvent(data) {
  if (!data || !data.items) return;

  const user = data.userDetails || {};
  const nameParts = (user.name || "").split(" ");
  const firstName = nameParts[0] || "";
  const lastName = nameParts.slice(1).join(" ") || "";

  const ecommerceItems = data.items.map((item, index) => ({
    item_id: String(item.id || item.item_id || ""),
    item_name: item.name || item.item_name || "",
    affiliation: item.affiliation || "",
    coupon: item.coupon || "",
    discount: item.discount || 0,
    item_brand: item.item_brand || "",
    item_category: item.item_category || "",
    item_list_id: item.item_list_id || "",
    item_list_name: item.item_list_name || "",
    item_variant: String(item.variant || ""),
    price: item.price,
    quantity: item.quantity,
  }));

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "order-placed",
    phone_num: user.phone || "",
    first_name: firstName,
    last_name: lastName,
    email: user.email || "",
    city: user.city || "",
    state: user.state || "",
    pincode: user.postalCode || "",
    country: user.countryCode || "",
    ecommerce: {
      currency: data.currency || "INR",
      value: data.totalPrice || data.value || 0,
      coupon: "",
      tax: 0,
      shipping: data.shippingCharge || 0,
      transaction_id: data.shopOrderId || "",
      paymentType: "", // Not provided in payload
      shipping_tier: "", // Not provided in payload
      items: ecommerceItems,
    },
  });
}